// extracted by mini-css-extract-plugin
export var container = "_50-0";
export var containerTopRight = "_50-1";